import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import { waLink } from '../data/site';
const { FaWhatsapp } = FaIcons;
export default function WhatsAppFloat() {
  return (
    <a className="wa-float" href={waLink()} target="_blank" rel="noopener noreferrer" aria-label="Chat with us on WhatsApp">
      <span className="wa-ic"><SafeIcon icon={FaWhatsapp} /></span>
      <span>Contact Us</span>
    </a>
  );
}
